import axios, { AxiosResponse } from "axios";
import config from "app-config/config.json";
import { resetToastMessages, toastMessage } from "utills/helpers";

const BASE_URL = config.WORKSPACE_API + `/api`;

let headers = {} as any;

export default class ApiService {
  static get = async (endpoint: string) => {
    try {
      const user = localStorage.getItem("USER");
      const lang = localStorage.getItem("lang");

      headers["accept-language"] = lang && lang !== "" ? lang : "vi";

      if (user) {
        const token = JSON.parse(user).token;

        headers["access-token"] = token && token !== "" ? token : "";
      }

      const response: AxiosResponse = await axios.get(
        `${BASE_URL}/${endpoint}`,
        { headers }
      );
      return response.data.data;
    } catch (error: any) {
      console.log("ApiService error:", error);

      const lang = localStorage.getItem("lang");
      const generalMsg =
        lang === "vi"
          ? "Thực hiện yêu cầu không thành công"
          : "Execute request failed";
      const msg = error.response.data.message
        ? error.response.data.message
        : generalMsg;

      toastMessage(msg);

      if (error.response.data.status_code === 401) {
        const intervalLogout = setInterval(() => {
          forceLogoutUser();
          resetToastMessages();
          clearInterval(intervalLogout);
        }, 2000);
      }

      // Clear localstorage toast message
      const intervalToast = setInterval(() => {
        resetToastMessages();
        clearInterval(intervalToast);
      }, 2000);

      throw error.response.data;
    }
  };
}

export const forceLogoutUser = () => {
  localStorage.removeItem("USER");
  localStorage.setItem("expired", "true");
  window.location.href = "/login";
};
